function Homepage() {
    return (
        <h1 className="text-3xl font-bold underline">
        Home page
      </h1>
    )
}

export default Homepage;